import React from 'react'
import ValidationSchema from './ValidationSchema'
import { components } from 'cng-web-lib'
import ConnectorTranslationText from '../ConnectorTranslationText'
import { Card, CardContent, Grid } from '@material-ui/core'
import AccordionHeaderComponent from '../../../common/ui/AccordionHeaderComponent'


const {
  form: {
    field: {
      CngTextField,
      CngSwitchField
    }
  }, CngGridItem
} = components


function Fields({ ...props }) {

  const { disabled } = props
  const {
    connectorCredentials, credentialName, isActive, key, accountNumber, password, existingPassword, meterNumber, secret
  } = ConnectorTranslationText()


  return (<>
      <Grid container spacing={3}>
        <CngGridItem xs={12} sm={12}>
          <Card>
            <CardContent>
              <Grid container>

                <AccordionHeaderComponent
                  title={connectorCredentials} />

                <Grid container spacing={3}>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      required
                      name='name'
                      label={credentialName}
                      disabled={disabled}
                    />

                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngSwitchField
                      name='isActive'
                      label={isActive}
                      disabled={disabled}
                    />
                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='key'
                      label={key}
                      disabled={disabled}
                    />
                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='secret'
                      label={secret}
                      disabled={disabled}
                    />
                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='accountNumber'
                      label={accountNumber}
                      disabled={disabled}
                    />

                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='meterNumber'
                      label={meterNumber}
                      disabled={disabled}
                    />

                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='password'
                      label={password}
                      disabled={disabled}
                    />
                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      name='existingPassword'
                      label={existingPassword}
                      disabled={disabled}
                    />
                  </CngGridItem>

                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </CngGridItem>
      </Grid>
    </>

  )
}


function toClientDataFormat(serverData) {
  return serverData
}

function toServerDataFormat(localData) {
  return localData
}

const DEFAULT_INITIAL_VALUES = {
  name: '', isActive: true, key: '', accountNumber: '', password: '', meterNumber: '', secret: '', existingPassword: ''
}

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }, makeValidationSchema: ValidationSchema
}

const ConnectorCredentialsFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default ConnectorCredentialsFormProperties